import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import Container from '@mui/material/Container';
import Typography from '../components/Typography';
import TextField from '../components/TextField';
import Snackbar from '../components/Snackbar';
import Button from '../components/Button';
import { sendMessage } from '../../../../API/zoekedAPI';
import moment from "moment";
import validator from 'validator'


function ProductCTA() {
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [error, setError] = React.useState(false);


  const handleClose = () => {
    setOpen(false);
  };

  const handleChangedEmail = () => {
    setError(false)
  }

  const handleSubmit = async (event) => {

    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email');

    if (validator.isEmail(data.get('email'))) {

      const adminMessage = {
        to: 'trevor.scullion@spatialbiz.com',
        from: email,
        subject: 'Insider signup from Abraxas',
        html: `${email} has signed up to get more information on Abraxas when we launch`,
        dateSent: moment().format('YYYY-MM-DD[T00:00:00.000Z]')
      }

      // make request to api to send message
      await sendMessage(adminMessage).then(data => {
        if (data.error) {
          setError(true)
        } else {
          const userMessage = {
            to: email,
            from: 'trevor.scullion@spatialbiz.com',
            subject: 'Your in the know on Abraxas',
            html: `Hello ${email}, <br/><br/>You are signed up to get the latest information when we launch Abraxas. <br/><br/>Thank you`,
            dateSent: moment().format('YYYY-MM-DD[T00:00:00.000Z]')
          }

          sendMessage(userMessage).then(data => {
            if (data.error) {
              setError(true)
            } else {
              setSuccess(true)
              setError(false)
            }
          });
        }
      });

    } else {
      setError(true)
    }
  };



  return (
    <div id="signup">
      <Container component="section" sx={{ mt: 10, display: 'flex' }}>
        <Grid container>
          <Grid item xs={12} md={6} sx={{ zIndex: 1 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                bgcolor: 'warning.main',
                py: 8,
                px: 3,
              }}
            >
              <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400 }}>
                <Box
                  component="img"
                  sx={{
                    height: 64,
                  }}
                  href="/"
                  alt="Abraxas"
                  src="/images/AbraxasLogoOnWhite.png"
                />
                <Typography variant="h3" component="h3" gutterBottom>

                  Become an Insider
                </Typography>
                {error &&
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert severity="error"> Invalid Email!</Alert>
                  </Stack>
                }
                {success &&
                  <Stack sx={{ width: '100%' }} spacing={2}>
                    <Alert severity="success">  Thanks for signing up!</Alert>
                  </Stack>
                }
                {!success && <Typography variant="h5">
                  Get in the know and be ready for our launch.
                </Typography>
                }
                <TextField
                  noBorder
                  id="email"
                  name="email"
                  placeholder="Your email"
                  variant="standard"
                  onChange={handleChangedEmail}
                  sx={{ width: '100%', mt: 3, mb: 2 }}
                />
                <Button
                  style={{ background: '#0d7abf' }}
                  type="submit"
                  color="primary"
                  variant="contained"
                  sx={{ width: '100%' }}
                >
                  Keep me updated
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: { md: 'block', xs: 'none' }, position: 'relative' }}
          >
            {/* <Box
              sx={{
                position: 'absolute',
                top: -67,
                left: -67,
                right: 0,
                bottom: 0,
                width: '100%',
                background: 'url(/images/onepirate/productCTAImageDots.png)',
              }}
            /> */}
            <Box
              component="img"
              src="/images/onepirate/DigitalTwinGraphic1.png"
              alt="call to action"
              sx={{
                position: 'absolute',
                top: -68,
                left: 38,
                right: 0,
                bottom: 0,
                width: '100%',
                maxWidth: 650,
              }}
            />
          </Grid>
        </Grid>
        <Snackbar
          open={open}
          closeFunc={handleClose}
          message="We will send you our best offers, once a week."
        />
      </Container>
    </div>
  );
}

export default ProductCTA;
